import PhotoSwipe from 'photoswipe';
import '../../sass/photoswipe/main.scss';

/** Create a gallery from image data, including API-provided w/h dimensions. */
export default function createPhotoSwipe(items, options = {}) {
    const dataSource = items.map(item => ({
        ...item,
        width: Number(item.width || item.w),
        height: Number(item.height || item.h),
    }));
    const index = Number(options.index) || 0;
    const gallery = new PhotoSwipe({
        ...options,
        dataSource,
        index: dataSource.length ? ((index % dataSource.length) + dataSource.length) % dataSource.length : 0,
        mainClass: 'application-photoswipe',
    });

    gallery.on('uiRegister', () => {
        gallery.ui.registerElement({
            name: 'caption',
            order: 9,
            isButton: false,
            appendTo: 'root',
            onInit: element => {
                gallery.on('change', () => {
                    element.textContent = gallery.currSlide.data.title || '';
                    element.hidden = !element.textContent;
                });
            },
        });
    });

    return gallery;
}
